export { default as Img200 } from './processed/200/trapezeartist.jpg';
export { default as Img400 } from './processed/400/trapezeartist.jpg';
export { default as Imgthumb } from './processed/thumb/trapezeartist.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/trapezeartist.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/trapezeartist.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      231,
      209,
      40
    ],
    "_population": 177,
    "_hsl": [
      0.1474694589877836,
      0.7991631799163179,
      0.5313725490196078
    ]
  },
  "LightVibrant": {
    "_rgb": [
      139,
      156,
      242
    ],
    "_population": 122,
    "_hsl": [
      0.6391585760517798,
      0.7984496124031006,
      0.7470588235294118
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      196,
      116,
      4
    ],
    "_population": 2,
    "_hsl": [
      0.09722222222222222,
      0.9599999999999999,
      0.3921568627450981
    ]
  },
  "Muted": {
    "_rgb": [
      101,
      102,
      149
    ],
    "_population": 610,
    "_hsl": [
      0.6631944444444444,
      0.19200000000000003,
      0.4901960784313726
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      160,
      203
    ],
    "_population": 37,
    "_hsl": [
      0.7945736434108528,
      0.2925170068027209,
      0.7117647058823529
    ]
  },
  "DarkMuted": {
    "_rgb": [
      73,
      60,
      52
    ],
    "_population": 439,
    "_hsl": [
      0.0634920634920635,
      0.16799999999999998,
      0.24509803921568626
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/trapezeartist.js